import React, {Component} from 'react';

class ReferenceLineLabel extends Component {
  render() {
    const {viewBox, text} = this.props;
    const labelPadding = 6;
    const verticalDisplacement = 4.5;
    const x = viewBox.width + viewBox.x + labelPadding;

    return (
      <text
        x={x}
        y={viewBox.y + verticalDisplacement}
        className='recharts-text recharts-label'
      >
        <tspan x={x}>{text}</tspan>
      </text>
    );
  }
}

export default ReferenceLineLabel;
